import { FlowHistoryType } from "./FlowHistoryType";
import { IConfigStorage } from "../../Common/IConfigStorage";

export class FlowHistory implements IConfigStorage {
    threadId: string;
    type: FlowHistoryType;
    elementId: string;
    outcomePath?: string;
    start: Date;
    end?: Date;

    constructor(threadId: string, type: FlowHistoryType, elementId: string) {
        this.threadId = threadId;
        this.type = type;
        this.elementId = elementId;
        this.start = new Date();
    }

    getStorageData(): object {
        let d = {};

        Reflect.set(d, "threadId", this.threadId);
        Reflect.set(d, "type", this.type);
        Reflect.set(d, "elementId", this.elementId);
        Reflect.set(d, "outcomePath", this.outcomePath);
        Reflect.set(d, "start", this.start);
        Reflect.set(d, "end", this.end);

        return d;
    }

    setStorageData(d: object): void {
        this.threadId = Reflect.get(d, "threadId");
        this.type = Reflect.get(d, "type");
        this.elementId = Reflect.get(d, "elementId");
        this.outcomePath = Reflect.get(d, "outcomePath");
        this.start = Reflect.get(d, "start");
        this.end = Reflect.get(d, "end");
    }
}
